<template>
    <v-ons-list-item
            tappable
            modifier="longdivider"
            v-bind:key="ability.id"
            v-bind:style="{min_height: '10px', padding: '0px 0px 0px 14px'}"
            v-on:click.prevent="onSelect(ability.id)"
    >
        <v-ons-row>{{ability.name}}</v-ons-row>

        <v-ons-row v-if="isSop(ability.group_id)">
            <v-ons-col class="item comment">{{ability.sop_comment}}</v-ons-col>
        </v-ons-row>
        <v-ons-row v-else-if="isShowComment(ability.group_id)">
            <v-ons-col class="item comment">{{ability.comment}}</v-ons-col>
        </v-ons-row>
        <v-ons-row v-else>
            <v-ons-col class="item hp" v-bind:style="{fontWeight: isGtZero(ability.hp)}">{{ability.hp}}</v-ons-col>
            <v-ons-col class="item pp" v-bind:style="{fontWeight: isGtZero(ability.pp)}">{{ability.pp}}</v-ons-col>
            <v-ons-col class="item s_atk" v-bind:style="{fontWeight: isGtZero(ability.s_atk)}">{{ability.s_atk}}</v-ons-col>
            <v-ons-col class="item r_atk" v-bind:style="{fontWeight: isGtZero(ability.r_atk)}">{{ability.r_atk}}</v-ons-col>
            <v-ons-col class="item t_atk" v-bind:style="{fontWeight: isGtZero(ability.t_atk)}">{{ability.t_atk}}</v-ons-col>
            <v-ons-col class="item dex" v-bind:style="{fontWeight: isGtZero(ability.dex)}">{{ability.dex}}</v-ons-col>
            <v-ons-col class="item s_def" v-bind:style="{fontWeight: isGtZero(ability.s_def)}">{{ability.s_def}}</v-ons-col>
            <v-ons-col class="item r_def" v-bind:style="{fontWeight: isGtZero(ability.r_def)}">{{ability.r_def}}</v-ons-col>
            <v-ons-col class="item t_def" v-bind:style="{fontWeight: isGtZero(ability.t_def)}">{{ability.t_def}}</v-ons-col>
        </v-ons-row>

    </v-ons-list-item>
</template>

<script>
    export default {
        name: "AbilityListItem",
        props: [
            'ability'
        ],
        methods: {
            onSelect(abilityId) {
                // 親へ選択されたIDを返したいの
                // this.$emit('on-select-list-item', abilityId);
                this.$eventHub.$emit('on-select-list-item', abilityId);
            },
            // isVisible(ability) {
            //     // 検索文字列が空の場合はvisibleに依存
            //     // if (!searchWord.length) {
            //     //     return ability.visible;
            //     // }
            //     // // 検索文字列と比較
            //     // if (ability.visible) {
            //     //     let regexp = RegExp('^(?=.*' + searchWord + ').*$');
            //     //     if (regexp.test(ability.search_name)) {
            //     //         return true;
            //     //     }
            //     // }
            //     // return false;
            //     return (ability.visible && ability.matched);
            // },
            isGtZero(num) {
                return num > 0 ? 'bold' : 'normal';
            },
            isSop(groupId) {
                return [101, 102, 103, 104].indexOf(groupId) !== -1;
            },
            isShowComment(groupId) {
                return [52, 53, 54].indexOf(groupId) !== -1
            }
        },
        data() {
            return {

            }
        }
    }
</script>

<style scoped>
    .item {
        text-align: center;
    }
    .item.comment {
        text-align: left;
    }
    .s_atk, .s_def {
        background-color: #FEE;
    }
    .r_atk, .r_def {
        background-color: #EEF;
    }
    .t_atk, .t_def {
        background-color: #FFE;
    }
    .dex {
        background-color: #EFE;
    }
</style>
